export default __webpack_public_path__ + "static/media/left-arrow.dd6be1da.svg";